export const STORAGE_KEY     = 'accesspro-cookie-consent';
export const STORAGE_VERSION = 1;
// Bump POLICY_VERSION whenever the cookie/privacy policy or vendor list changes
// so existing visitors are re-prompted (GDPR re-consent on substantive change).
export const POLICY_VERSION  = '2026-04-27';
export const EXPIRY_MS       = 15552000000; // 6 months
export const BANNER_ID       = 'acb-banner';
export const PREFS_ID        = 'acb-preferences';
export const OVERLAY_ID      = 'acb-overlay';
export const STYLES_ID       = 'acb-styles';
export const COOKIE_ICON_ID  = 'acb-cookie-icon';

// ISO 3166-1 alpha-2 → region key array
export const COUNTRY_REGIONS = {
  // Europe (EU/EEA/associated)
  AT:['europe'],BE:['europe'],BG:['europe'],CY:['europe'],CZ:['europe'],
  DK:['europe'],EE:['europe'],FI:['europe'],FR:['europe'],DE:['europe'],
  GR:['europe'],HU:['europe'],IE:['europe'],IT:['europe'],LV:['europe'],
  LT:['europe'],LU:['europe'],MT:['europe'],NL:['europe'],PL:['europe'],
  PT:['europe'],RO:['europe'],SK:['europe'],SI:['europe'],ES:['europe'],
  SE:['europe'],HR:['europe'],MK:['europe'],AL:['europe'],BA:['europe'],
  ME:['europe'],RS:['europe'],IS:['europe'],LI:['europe'],AD:['europe'],
  MC:['europe'],SM:['europe'],VA:['europe'],MD:['europe'],UA:['europe'],
  BY:['europe'],XK:['europe'],
  NO:['europe','norway'],
  CH:['europe','switzerland'],
  GB:['europe','uk'],
  RU:['europe','china'],
  // Americas
  US:['usa'],
  CA:['canada'],
  MX:['mexico'],GT:['mexico'],BZ:['mexico'],HN:['mexico'],SV:['mexico'],
  NI:['mexico'],CR:['mexico'],PA:['mexico'],
  BR:['brazil'],
  AR:['argentina'],UY:['argentina'],PY:['argentina'],
  // East Asia
  JP:['japan'],
  CN:['china'],HK:['china'],MO:['china'],MN:['china'],KP:['china'],TW:['china'],
  KR:['china','south_korea'],
  // South Asia
  IN:['india'],LK:['india'],NP:['india'],BT:['india'],MV:['india'],
  // Southeast Asia
  TH:['thailand'],MM:['thailand'],KH:['thailand'],LA:['thailand'],
  VN:['thailand'],MY:['thailand'],SG:['thailand'],ID:['thailand'],
  PH:['thailand'],BN:['thailand'],TL:['thailand'],
  // Middle East / UAE
  AE:['uae'],SA:['uae'],TR:['uae'],JO:['uae'],SY:['uae'],IQ:['uae'],
  IR:['uae'],OM:['uae'],QA:['uae'],BH:['uae'],KW:['uae'],YE:['uae'],
  LB:['uae'],IL:['uae'],PS:['uae'],
  // Australia / Pacific
  AU:['australia_nz'],NZ:['australia_nz'],PG:['australia_nz'],FJ:['australia_nz'],
  // Africa
  ZA:['south_africa'],NA:['south_africa'],BW:['south_africa'],SZ:['south_africa'],
  LS:['south_africa'],ZW:['south_africa'],MZ:['south_africa'],MW:['south_africa'],
  ZM:['south_africa'],TZ:['south_africa'],KE:['south_africa'],UG:['south_africa'],
  RW:['south_africa'],BI:['south_africa'],SC:['south_africa'],MU:['south_africa'],
  MG:['south_africa'],ET:['south_africa'],SO:['south_africa'],ER:['south_africa'],
  DJ:['south_africa'],NG:['south_africa'],GH:['south_africa'],CI:['south_africa'],
  GN:['south_africa'],ML:['south_africa'],MR:['south_africa'],NE:['south_africa'],
  SN:['south_africa'],SL:['south_africa'],GM:['south_africa'],GW:['south_africa'],
  CM:['south_africa'],CF:['south_africa'],TD:['south_africa'],CG:['south_africa'],
  CD:['south_africa'],GA:['south_africa'],ST:['south_africa'],AO:['south_africa'],
  BJ:['south_africa'],TG:['south_africa'],BF:['south_africa'],EG:['south_africa'],
  LY:['south_africa'],TN:['south_africa'],MA:['south_africa'],DZ:['south_africa'],
  SD:['south_africa'],SS:['south_africa'],
};
